var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"slot",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('jds-icon',{staticClass:"jds-mr-1"},[_c('jds-glyph',{attrs:{"for":"add"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }